import React, {useState} from 'react';
import { useSelector, connect} from 'react-redux';
import { Modal, Button } from 'rsuite';
import * as actionsPolicy  from '../../../../app/actions/policy';
import {isCyrilicFound, isLatinFound} from '../../../../app/common/services/vehicle.service';
import { NuInsInputTextLabel, NuInsInputNumLabel, NuInsSelectLabel } from '../elements/inputFieldsLabel';
import { CheckBoxCustom } from '../elements/inputFields';
import {insCompanyTypes} from '../../../../app/common/types/insCompTypes';

const OwnerDetailsCompany = ({updateOwnerDetails, onSubmit}) => {

    const ownerDetails = useSelector(state => state.ownerDetails);
    
    const [checkFields, setCheckFields] = useState({});
    const [showCompanyType, setShowCompanyType] = useState(false);
    const [ownerRepresentitive, setOwnerRepresentitive] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const companyTypeOptions = Object.keys(insCompanyTypes).map(type => ({label: insCompanyTypes[type], value: type, role: "Master"}));

    const inputFields = ['eik', 'companyNameCyrillic', 'companyNameLatin', 'companyType'];
    const errorMsg    = "Полето е задължително";

    const onChangeHandler = (field, data) =>  {
        updateOwnerDetails({[field]: data});
    }

    const onBlurHandler = (field) =>  {
        if(field === 'companyNameCyrillic' && ownerDetails[field] && !checkForError('companyNameCyrillic', 'cyrilic', true)) {
            setShowCompanyType(true);
        } 
    
        setCheckFields({...checkFields, [field]: true});
    }

    const checkForError = (field, type, allFields) =>  {
        switch (type) {
            case 'cyrilic':
                const nonCyrFound = ownerDetails[field] ? isLatinFound(ownerDetails[field]) : false;
                return (checkFields[field] || allFields) && (nonCyrFound || !ownerDetails[field]);
            case 'latin':
                const cyrFound = ownerDetails[field] ? isCyrilicFound(ownerDetails[field]) : false;
                return (checkFields[field] || allFields) && (cyrFound || !ownerDetails[field]);
            case 'id':
                return (checkFields[field] || allFields) && (!ownerDetails[field] || (ownerDetails[field]?.length != 9 && ownerDetails[field]?.length != 13) );
            default:
                return (checkFields[field] || allFields) && !ownerDetails[field];
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'cyrilic':
                return `${errorMsg} ${ownerDetails[field] ? 'на кирилица' : ''}`;
            case 'latin':
                return `${errorMsg} ${ownerDetails[field] ? 'на латиница' : ''}`;
            case 'id':
                return `${errorMsg} ${ownerDetails[field] ? '9 или 13 символа' : ''}`;
            default:
                return errorMsg;
        }
    }

    const onChangeRepHandler = (data) => {
        setOwnerRepresentitive(data);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const valdateAllFields = () => {

        for(let field of inputFields) {
            if(field.includes('Cyr')) {
                if(checkForError(field, 'cyrilic', true)) return false;
            } else if (field.includes('Latin')) {
                if(checkForError(field, 'latin', true)) return false;
            } else if (field === 'eik') {
                if(checkForError(field, 'id', true)) return false;
            } else {
                if(checkForError(field, null, true)) return false;
            }
        }

        return true;
    }

    const submitHandler = (event) => {
        event.stopPropagation()
        setCheckFields(inputFields.reduce((acc, field) => ({...acc, [field]: true}) , {}));

        if(!ownerRepresentitive) {
            setShowModal(true);
            return;
        }

        if(valdateAllFields()) {
            onSubmit();
        }
    }

    return (
        <div className="steps_container-form show-loading" >

            <h6 style={{paddingLeft:"2rem", fontWeight: '500'}}>Собственик </h6>
            <h6 style={{paddingLeft:"2rem",color:"#6bdfa7", fontWeight: '500', marginBottom: '1rem'}}>Юридическо лице</h6>

            <NuInsInputNumLabel onChange={(data)=>onChangeHandler('eik', data)} onBlur={()=>onBlurHandler('eik')} 
                slice={13} 
                placeholder={"ЕИК"} 
                value={ownerDetails['eik']} 
                error={checkForError('eik', 'id')} 
                errorMsg={generateErrorMsg('eik', 'id')}
                styles={{marginBottom: '20px'}}/>
        
            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('companyNameCyrillic', data)} onBlur={()=>onBlurHandler('companyNameCyrillic')} 
                placeholder={"Име на компанията"} 
                value={ownerDetails['companyNameCyrillic']} 
                error={checkForError('companyNameCyrillic', 'cyrilic')} 
                errorMsg={generateErrorMsg('companyNameCyrillic', 'cyrilic')}/>
            <p className="secondary-text" style={{marginBottom: '.5rem', fontSize: '10px'}}>Пример: АБВ ЕООД</p>

            <NuInsInputTextLabel onChange={(data)=>onChangeHandler('companyNameLatin', data)} onBlur={()=>onBlurHandler('companyNameLatin')} 
                placeholder={"Име на компанията на латиница"} 
                value={ownerDetails['companyNameLatin']} 
                error={checkForError('companyNameLatin', 'latin')} 
                errorMsg={generateErrorMsg('companyNameLatin', 'latin')}/>
            <p className="secondary-text" style={{marginBottom: '.5rem', fontSize: '10px'}}>Example: ABV EOOD</p>
            {showCompanyType &&
                <>
                <NuInsSelectLabel onChange={(data)=>onChangeHandler('companyType', data)} onBlur={()=>onBlurHandler('companyType')} 
                    placeholder={"Тип на компанията"}
                    options={companyTypeOptions}
                    value={ownerDetails['companyType']} 
                    error={checkForError('companyType')} 
                    errorMsg={generateErrorMsg('companyType')}
                    styles={{marginBottom: '20px'}}/>
                </>
            }
            
            <div className="steps_container-checkbox" style={{marginTop: '20px'}}>
                <CheckBoxCustom onChange={onChangeRepHandler} value={ownerRepresentitive}/>
                <div>Аз съм представител на юридическото лице</div>
            </div>

            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={submitHandler}>Продължи</button>
            
            {/* Modal for representitive */}
            <Modal size="xs" show={showModal} onHide={() => closeModal()}>
                <Modal.Body>
                    <p className="no-reg-data">Не можеш да сключиш полица, ако не си представител на юридическото лице</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} >Ok</Button>
                </Modal.Footer>
            </Modal>
            
        </div>
    )

}

export default connect(null, {...actionsPolicy})(OwnerDetailsCompany);